export const statisticComponent = () => {
    // var $ = jQuery.noConflict();

    /* Script on load
    ------------------------------------------------------------------------------*/
    window.addEventListener('load', handleCounters);

    /* Script on scroll
    ------------------------------------------------------------------------------*/
    window.addEventListener('scroll', handleCounters);

    /* Script on resize
    ------------------------------------------------------------------------------*/
    window.addEventListener('resize', handleCounters);

    /* Counter Functions
    ------------------------------------------------------------------------------*/
    function handleCounters() {
        jQuery('.statistics-block-section .statistics-items').each(function() {
            if (isPartiallyVisible(jQuery(this))) {
                startCounters(jQuery(this));
            }
        });
    }

    function startCounters(elem) {
        const spMainSec = jQuery(elem);
        if (spMainSec.length) {
            const sectionTop = spMainSec.offset().top;
            const windowHeight = jQuery(window).height();
            const counterAnimated = spMainSec.data('counter-animated');

            if (!counterAnimated && jQuery(window).scrollTop() > sectionTop + 200 - windowHeight) {
                spMainSec.find('.stat-counter').each(function() {
                    const spCounter = jQuery(this);

                    if (!spCounter.hasClass('counted')) {
                        const originalValue = spCounter.data('count').toString();
                        const cleanedValue = originalValue.replace(/,/g, '');
                        const finalValue = parseFloat(cleanedValue);

                        if (!isNaN(finalValue)) {
                            const duration = finalValue < 10 ? 800 : 1200;
                            spCounter.text('0');

                            setTimeout(function() {
                                jQuery({ counter: 0 }).animate(
                                    { counter: finalValue },
                                    {
                                        duration: duration,
                                        easing: 'swing',
                                        step: function(now) {
                                            const formatted = applyCustomFormat(
                                                originalValue,
                                                now.toFixed(getDecimalPlaces(originalValue)),
                                            );
                                            spCounter.text(formatted);
                                        },
                                        complete: function() {
                                            spCounter.text(originalValue); // Ensure final exact value
                                            spCounter.addClass('counted');
                                        },
                                    },
                                );
                            }, 100);
                        }
                    }
                });

                spMainSec.data('counter-animated', true);
            }
        }
    }

    function getDecimalPlaces(number) {
        const parts = number.split('.');
        return parts.length > 1 ? parts[1].length : 0;
    }

    // ✅ UPDATED FUNCTION BELOW
    function applyCustomFormat(originalValue, currentNumber) {
        const numValue = parseFloat(currentNumber);
        const decimalPlaces = getDecimalPlaces(originalValue);

        if (numValue < 1000) {
            // No comma formatting
            return numValue.toFixed(decimalPlaces);
        } else {
            // Use comma formatting
            return Number(numValue.toFixed(decimalPlaces)).toLocaleString('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        }
    }

    function isPartiallyVisible(element) {
        const elementTop = element.offset().top;
        const elementBottom = elementTop + element.outerHeight();
        const viewportTop = jQuery(window).scrollTop();
        const viewportBottom = viewportTop + jQuery(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }
};
